import { o2oApi } from 'yxt-biz-pc/packages/api';

// 记录学员最近学习的任务
export const getRecentLea = ({projectId, taskId}) => {
  return o2oApi.get(`study/student/recent/learn/${projectId}/${taskId}`);
};

// 校验任务是否可以跳转
export const precheckTask = ({projectId, taskId, type}) => {
  // type 0 上一个 ； 1 下一个
  return o2oApi.get(`study/project/${projectId}/${taskId}?type=${type}`);
};

// 校验是否只有一个任务
export const checkTaskOnlyOne = (projectId) => {
  return o2oApi.get(`projectTask/${projectId}/only_one`);
};
